// extracted by mini-css-extract-plugin
export default {"snackbar":"S_9ZJ37SJJ_pdp","top":"OLczhypA8Z_pdp","bottom":"jwXFtUxrCN_pdp","center":"K3XwLJfnUq_pdp","start":"QpIXOBJbFn_pdp","end":"ehZ_8JYPnP_pdp"};